import { render, staticRenderFns } from "./AlertDisplay.vue?vue&type=template&id=95518d20"
import script from "./AlertDisplay.vue?vue&type=script&lang=js"
export * from "./AlertDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports